import { format } from "date-fns";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import {
  deleteCookie,
  getCookie,
  setCookie,
  setCookieForOneYear,
} from "./CookieComponent";

// Image Fetch
export const toAbsoluteUrl = (pathname) =>
  process.env.PUBLIC_URL + "/" + pathname;

// Title Change While Page Changes
export const ChangeTitle = (title) => {
  useEffect(() => {
    document.title = "GCC Law Help | " + title;
  }, []);
};

// React Select Style
export const selectStyle3 = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#DCD1B6",
    border: "none",
    boxShadow: "none",
    ":hover": {
      border: "none",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#2c3451",
    ":hover": {
      color: "#2c3451",
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "1.6rem",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};
export const selectStyle = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#DCD1B6",
    border: "none",
    boxShadow: "none",
    ":hover": {
      border: "none",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#2c3451",
    ":hover": {
      color: "#2c3451",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const selectStyle2 = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
    borderRadius: 0,
    border: "none",
    boxShadow: "none",
    ":hover": {
      border: "none",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#2c3451",
    ":hover": {
      color: "#2c3451",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const selectFormStyle = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#f0f0f0",
    border: "none",
    boxShadow: "none",
    ":hover": {
      border: "none",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#2c3451",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#2c3451",
    ":hover": {
      color: "#2c3451",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const selectFormStyle2 = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#c99930",
    border: "none",
    boxShadow: "none",
    ":hover": {
      border: "none",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#fff",
    ":hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "#fff" : "#333", // Different color when selected
    backgroundColor: state.isSelected ? "#c99930" : "#fff",
    fontFamily: "", // Apply Gilroy font to options
    fontWeight: "500",
    "&:hover": {
      backgroundColor: state.isSelected ? "#c99930" : "#fff9eb", // Background on hover
      // color: "#2c3451", // Background on hover
    },
  }),
};

export function LogOutSweetAlert() {
  return Swal.fire({
    title: "Are you sure?",
    text: "You want to Logout?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    customClass: {
      confirmButton: "btn-yes mr-[1rem]",
      cancelButton: "btn-no ml-[1rem]",
    },
    buttonsStyling: false,
  });
}

export function CancelSweetAlert() {
  return Swal.fire({
    title: "Are you sure?",
    text: "Do you want to cancel the order?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    customClass: {
      confirmButton: "btn-yes mr-[1rem]",
      cancelButton: "btn-no ml-[1rem]",
    },
    buttonsStyling: false,
  });
}

export function DeletSweetAlert() {
  return Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete the record?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    customClass: {
      confirmButton: "btn-yes mr-[1rem]",
      cancelButton: "btn-no ml-[1rem]",
    },
    buttonsStyling: false,
  });
}

export function toasterrormsg(message) {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
}

export function toastsuccessmsg(message) {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
}
export function toastsuccessmsg2(message, sec = 2000) {
  toast.success(message, {
    position: "top-right",
    autoClose: sec,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
}

export const dateFormat = (date) => {
  return format(new Date(date), "dd-MM-yyyy");
};

export const dateFormat2 = (date) => {
  return format(new Date(date), "dd MMM yyyy");
};

// Define key and IV (without special characters)
const key = CryptoJS.enc.Utf8.parse("EHfIFLyhqOEiSnzeGCGkpQ=="); // 32-byte key
const iv = CryptoJS.enc.Utf8.parse("pvS2vRv8MnPyDUrU"); // 16-byte IV

// Encrypt function
export const encrypt = (text) => {
  const stringTxt = String(text); // Ensure the input is a string

  let cipher = CryptoJS.AES.encrypt(stringTxt, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  // Get the Base64 string and remove the padding '=' characters
  let base64String = cipher.toString(CryptoJS.format.Base64);
  base64String = base64String.replace(/=/g, ""); // Remove '=' padding characters

  // URL-encode the encrypted result
  return encodeURIComponent(base64String);
};

// Decrypt function
export const decrypt = (encryptedText) => {
  // Decode the URL-encoded string
  let decodedText = decodeURIComponent(encryptedText);

  // Add the padding back ('==') to the decoded Base64 string
  decodedText = decodedText + "=="; // Restore the Base64 padding

  // Decrypt the string
  let bytes = CryptoJS.AES.decrypt(decodedText, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  return bytes.toString(CryptoJS.enc.Utf8); // Return the decrypted result
};

// Encrypt an object by serializing it to a JSON string
export const encryptState = (data) => {
  const jsonString = JSON.stringify(data); // Convert object to JSON string
  return encrypt(jsonString); // Use your existing encrypt function
};

// Decrypt and parse the JSON string back to an object
export const decryptState = (data) => {
  const decryptedText = decrypt(data); // Use your existing decrypt function
  return JSON.parse(decryptedText); // Parse JSON string back to object
};

export const encryptUrlData = (data) => {
  try {
    return encodeURIComponent(encryptState(data));
  } catch (error) {
    console.log("URL Encryption Error", error);
    return;
  }
};

export const decryptUrlData = (data) => {
  try {
    return data ? decryptState(decodeURIComponent(data)) : {};
  } catch (error) {
    console.error("Failed to decrypt URL data:", error);
    return {}; // Fallback in case of error
  }
};

export const getEncodedCookie = (key) => {
  const encryptedKey = encrypt(key);
  const cookieValue = getCookie(encryptedKey);
  return cookieValue ? decrypt(cookieValue) : "";
};

export const checkValue = (value) => {
  if (value != "" && value != null && value != undefined) {
    return value;
  } else {
    return "";
  }
};

export const setEncodedCookie = (key, value) => {
  let formattedValue;

  switch (typeof value) {
    case "object":
      formattedValue = JSON.stringify(value);
      break;
    case "number":
      formattedValue = String(value);
      break;
    default:
      formattedValue = value;
      break;
  }

  setCookie(encrypt(key), encrypt(formattedValue), {});
};

export const setEncodedCookieOneYear = (key, value) => {
  let formattedValue;

  switch (typeof value) {
    case "object":
      formattedValue = JSON.stringify(value);
      break;
    case "number":
      formattedValue = String(value);
      break;
    default:
      formattedValue = value;
      break;
  }

  setCookieForOneYear(encrypt(key), encrypt(formattedValue));
};

export const deleteEncodedCookie = (key) => {
  const encryptedKey = encrypt(key);
  deleteCookie(encryptedKey);
  //   return cookie && decrypt(cookie);
};
export const typeList = [
  { value: "Shipping", label: "Shipping" },
  { value: "Billing", label: "Billing" },
];